
import { useEffect } from 'react'
import Select from 'react-select'
import { WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const WardNameDataDDL = (props) => {
    const { WardName, setWardName, IsPost, DDLname, Flag, APIFlag, rowData, Type, IsDisabled, isClearable, HWard, WLable, SectorName, setSectorName, DashProjectTypeId } = props
    // console.log(rowData)
    const userDetails = useAuthState();
    const { UserID, RoleID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { WardName, UserID, token, handleWardNameDDL, Type, APIFlag }
        dispatch(WardNameDDLAPI({ data }))
    }, [IsPost])
    const { WardDDLData } = useSelector(state => state.WardNameDDLData)

    const handleWardNameDDL = (WardDDLData) => {
        if (WardDDLData && WardDDLData.table && WardDDLData.table.length > 0) {
            let list = WardDDLData.table.map((item, index) => ({
                value: Type == "Electrical" ? item.m_WardID : item.id,
                label: item.wardName,
            }))
            if (Type == "Electrical") {
                setWardName({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData?.m_WardID : 0,
                    Label: Flag === 'Update' ? rowData?.wardName : 'Select...'
                })
            } else {
                setWardName({
                    DDL: list,
                    ID: (RoleID == '16' || DashProjectTypeId == '1') ? 0 : Flag === 'Update' ? rowData.m_WardID : Flag === 'Ward' ? list[0].value : HWard ? HWard : 0,
                    Label: (RoleID == '16' || DashProjectTypeId == '1') ? "Select..." : Flag === 'Update' ? rowData.wardName : Flag === 'Ward' ? list[0].label : WLable ? WLable : 'Select...'
                })
            }
        }
        else {
            setWardName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">

            <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name {Flag && <AstricSign />} </b></label>

            <Select
                isClearable={isClearable === false ? false : true}
                // isRtl={isRtl}
                // className='ddl_width3'
                isDisabled={Flag === 'Update' && IsDisabled ? true : false}
                isSearchable
                maxMenuHeight={115}
                value={{ value: WardName.ID, label: WardName.Label }}
                onChange={(e) => {
                    e ?
                        setWardName({ ...WardName, ID: e.value, Label: e.label })
                        :
                        setWardName({ ...WardName, ID: 0, Label: "Select..." })
                    { setSectorName && setSectorName({ ...SectorName, ID: 0, Label: "Select..." }) }

                }}
                options={WardName.DDL}
            />
        </div>
    )
}